module.exports = __webpack_public_path__ + "img/prize-02.cbe74ef2.png";